import { render, staticRenderFns } from "./SettingAgreementItem.vue?vue&type=template&id=01459aa4&scoped=true&"
import script from "./SettingAgreementItem.vue?vue&type=script&lang=js&"
export * from "./SettingAgreementItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingAgreementItem.vue?vue&type=style&index=0&id=01459aa4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01459aa4",
  null
  
)

export default component.exports